define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Number"
], function(declare,_,NumberRen) {
	
	return declare(NumberRen, {
		pushContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: ignore heading path when rendering nodes other than Question
			ctx.pushParams();
			return true;
		},
		
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: rollup PointsPossible from children if not on node itself
			var	node = ctx.getNode();
			if (node.$Type != "QuestionRevision") {
				return ctx.view.getPointsPossible(ctx.getNodeURL());
			}
			
			return node.PointsPossible;
		}
	});
});